import { useQuery } from '@tanstack/react-query'

import { api } from '../../../shared/api'

/** Entries per content language (ADR-042). */
export function useEntryLocaleStats(enabled = true) {
  return useQuery({
    queryKey: ['entries', 'locale-stats'],
    queryFn: () => api<Record<string, number>>('/entries/locale-stats'),
    enabled,
  })
}
